import { connect } from 'react-redux';

import AppMeta, { StateProps } from './app-meta';
import { getSettings } from 'client/ducks/app/selectors';
import { State } from 'client/store';

function mapStateToProps(state: State): StateProps {
    return {
        data: getSettings(state)
    };
}

export default connect<StateProps>(mapStateToProps)(AppMeta) as any;
